import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { translate } from '../../../../base/i18n';
import {
    bindConvenienceFeeAmount,
    bindDonationOrderItems,
    bindFinalDonationAmount,
    bindFinalDonationAmountError,
    bindHaslessInstallmentAmt,
    bindInstallements,
    bindInstallmentChargeValue,
    bindInstallmentError,
    bindInstallmentErrorMsg,
    bindIsInDefiniteRecurring,
    bindIsInstallmentTouched,
    bindMeetFormData
} from '../../../actions';
import { CalcConvenienceFee as calcConvenienceFee, calculateEndPeriod, getDecimalPoint, getPaymentAmount, getRemovedFee, getTaxDeductableAmount, removedecimal } from '../utility/util';


const Installments = ({ t }) => {

    const marginTopStyle = { marginTop: '0.2rem' };
    const numberFormatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });

    const meetFormData = useSelector(
    state => state['features/clickandpledge']?.meetFormData || {}
    );
    const recurring = useSelector(
      state => state['features/clickandpledge']?.amountSection || {}
    );
    const recurringselection = useSelector(
    state => state['features/clickandpledge']?.recurringSelection || ''
    );
    const recurringMethods = useSelector(state => state['features/clickandpledge']?.recurringMethod || '');
    const periodicityEndDate = useSelector(state => state['features/clickandpledge']?.periodicityEndDate || '');
    const noofperiodicity = useSelector(state => state['features/clickandpledge']?.noofperiodicity || '');
    const donationamount = useSelector(
    state => state['features/clickandpledge']?.donationAmountSelected || ''
    );
    const finalInstallmentAmt = useSelector(
    state => state['features/clickandpledge']?.finalDonationAmt || ''
    );
    const installmentCharge = useSelector(
    state => state['features/clickandpledge']?.installmentCharge || ''
    );
    const installments = useSelector(
    state => state['features/clickandpledge']?.installementSelected || ''
    );
    const convFee = useSelector(
    state => state['features/clickandpledge']?.convenienceFeeAmount || ''
    );
    const convfeedata = useSelector(
    state => state['features/clickandpledge']?.convenienceFeeSection || []
    );
    const installmenterr = useSelector(
    state => state['features/clickandpledge']?.hasInstallmentError || false
    );
    const installmenterrmsg = useSelector(
    state => state['features/clickandpledge']?.installmentErrorMsg || ''
    );
    const IsInDefiniteRecurring = useSelector(
    state => state['features/clickandpledge']?.isIndefiniteRecurring || false
    );
    const formSettings = useSelector(
    state => state['features/clickandpledge']?.formSettings || {}
    );
    const IsConvFeeSelected = useSelector(
    state => state['features/clickandpledge']?.convenienceFeeSelected || false
    );
    const isInstallmentTouched = useSelector(
    state => state['features/clickandpledge']?.isInstallmentTouched || false
    );
    const donationOrderItems = useSelector(state => state['features/clickandpledge']?.donationOrderItems || {});

    const [ maxCalPeriods, setMaxCalPeriods ] = useState(0);
    const [ periodChange, setPeriodChange ] = useState(false);
    const [ isReadOnly, setIsReadOnly ] = useState(true);
    const [ isDisabled, setIsDisabled ] = useState(false);

    const dispatch = useDispatch();

    const rValue = useMemo(() => {
        if (meetFormData) {
            meetFormData.formdata.find(obj => obj.recurrings);
        }
    }, [ meetFormData ]);

    useEffect(() => {
        const checkEndDate = new Date(periodicityEndDate).getFullYear();

        if (checkEndDate === 1) { // checkEndDate 1 means date not given
            if ((recurring.PreSet || !isInstallmentTouched) && noofperiodicity > 0 && noofperiodicity <= 998) {
                setMaxCalPeriods(noofperiodicity);
                dispatch(bindInstallements(noofperiodicity));
            }
            if (recurring.PreSet) {
                setIsDisabled(true);
            } else {
                setIsDisabled(false);
            }
        }
    }, [ noofperiodicity, recurring, periodicityEndDate, isInstallmentTouched ]);

    useEffect(() => {
        if (installmenterr && donationamount) {
            dispatch(bindInstallmentErrorMsg(''));
            dispatch(bindInstallmentError(false));
            if (!recurring.PreSet) {
                dispatch(bindInstallements(''));
            }
        }


        if (!installmenterr) {

            const checkEndDate = new Date(periodicityEndDate).getFullYear();

            if (checkEndDate !== 1 && recurringMethods === 'Subscription') {

                const calperiod = calculateEndPeriod(recurringMethods, periodicityEndDate, recurringselection);

                if (calperiod && Object.keys(calperiod).length && calperiod.error) {
                    dispatch(
              bindInstallmentErrorMsg(calperiod.error),
              bindInstallmentError(true)
                    );
                } else if (calperiod && calperiod.data.toString().length <= 3) {
                    if (!isInstallmentTouched || recurring.PreSet) {
                        dispatch(bindInstallements(calperiod.data));
                    }
                    setMaxCalPeriods(calperiod.data);

                }
                if (recurring.PreSet) {
                    setIsDisabled(true);
                } else {
                    setIsDisabled(false);
                }


            }
            if (checkEndDate !== 1 && recurringMethods !== 'Subscription') {
                let installcount = 0;
                const boostUpVals = JSON.parse(sessionStorage.getItem('boostUp'));

                if (boostUpVals !== null && donationamount > 0) {
                    const calperiod = calculateEndPeriod(recurringMethods, periodicityEndDate, recurringselection);

                    if (calperiod && calperiod.data.toString().length <= 3) {
                        dispatch(bindInstallements(calperiod.data));
                        setMaxCalPeriods(calperiod.data);
                        installcount = calperiod.data;
                        if (donationamount < installcount) {
                            dispatch(bindInstallements(donationamount));
                            setMaxCalPeriods(donationamount);
                            installcount = donationamount;
                        }
                    }


                } else {
                    installcount = !installments && !IsInDefiniteRecurring ? 2 : installments;
                    if (installcount.toString().length <= 3) {

                        dispatch(bindInstallements(installcount));
                        setMaxCalPeriods(installcount);
                    }
                }
                const donAmt = recurringMethods !== 'Subscription' && installcount ? getDecimalPoint(donationamount, installcount, '') : parseFloat(donationamount);
                const calFee = calcConvenienceFee(donAmt, convfeedata.AdditionalFeePercentage, convfeedata.AdditionalFeeAmount,
                  installcount, recurringselection, convfeedata.AdjustFee, recurringMethods);
                const Damount = getPaymentAmount(donationamount, installcount, calFee, IsConvFeeSelected, recurringMethods, recurringselection);

                if (Damount !== -1) {
                    dispatch(bindInstallmentChargeValue(removedecimal(Damount)));
                    dispatch(bindFinalDonationAmount(removedecimal(Damount)));
                }
            }
        }
    }, [ donationamount, installmenterr, recurringselection, periodicityEndDate, recurringMethods, isInstallmentTouched, recurring.PreSet ]);

    useEffect(() => {
        if (recurringselection) {

            if (rValue && rValue.amountsection !== -1) {
                const Damount = getPaymentAmount(donationamount, installments, convFee, IsConvFeeSelected, recurringMethods, recurringselection);

                dispatch(bindInstallmentChargeValue(removedecimal(Damount)));
            }

        }

        if (!installments && !IsInDefiniteRecurring) {
            dispatch(bindIsInDefiniteRecurring(false));
        }
    }, [ recurringselection, rValue, donationamount, installments, convFee, IsConvFeeSelected, recurringMethods, IsInDefiniteRecurring, dispatch ]);

    const onRecBlur = () => {

        if (Object.keys(donationOrderItems).length) {
            const dotionItem = JSON.parse(JSON.stringify(donationOrderItems));

            const amt = IsConvFeeSelected ? getRemovedFee(installmentCharge, convFee) : installmentCharge;

            if (dotionItem.taxPercentage >= 0) {
                dispatch(bindDonationOrderItems({
                    itemId: dotionItem.itemId,
                    dItemName: dotionItem.dItemName,
                    dsku: dotionItem.dsku,
                    dgau: dotionItem.dgau,
                    fmv: dotionItem.fmv,
                    taxDeductible: getTaxDeductableAmount(amt, formSettings.TaxDeductible ? dotionItem.taxPercentage : 0, dotionItem.fmv),
                    taxPercentage: dotionItem.taxPercentage
                }));
            }
        }
        if (installmentCharge && installmentCharge < 1) {

            dispatch(
        bindInstallmentErrorMsg(t('clickandpledge.installmentAmountCannotBeLessThan', { currency: '$' }))
            );
            dispatch(bindInstallmentError(true));
            dispatch(bindHaslessInstallmentAmt(true));
        } else if (noofperiodicity > 0 && installments > noofperiodicity) {
            dispatch(
        bindInstallmentErrorMsg(
          t('clickandpledge.youCanSetUptoPeriods', { count: noofperiodicity })
        )
            );

            dispatch(bindInstallmentError(true));
        } else if (!IsInDefiniteRecurring && installments && installments < 2) {
            dispatch(
        bindInstallmentErrorMsg(t('clickandpledge.installmentsShouldNotLessThan2'))
            );

            dispatch(bindInstallmentError(true));
        } else if (maxCalPeriods > 0 && installments > maxCalPeriods && recurringMethods === 'Subscription') {
            dispatch(
        bindInstallmentErrorMsg(t('clickandpledge.installmentsShouldNotBeGreaterThan', { count: maxCalPeriods }))
            );
            dispatch(bindInstallmentError(true));
        } else {
            // setRecError('')
            dispatch(bindInstallmentErrorMsg(''));
            dispatch(bindInstallmentError(false));
            const Damount = getPaymentAmount(donationamount, recurringMethods === 'Subscription' ? '' : installments, convFee, IsConvFeeSelected, recurringMethods, recurringselection);

            dispatch(bindFinalDonationAmount(Damount));

            dispatch(
        bindMeetFormData({
            formdata: meetFormData.formdata
                ? meetFormData.formdata.map(q => {
                    return {
                        ...q,
                        recurrings: recurringselection,
                        amountsection: IsConvFeeSelected ? getRemovedFee(installmentCharge, convFee) : installmentCharge
                    };
                })
                : [ { amountsection: IsConvFeeSelected ? getRemovedFee(installmentCharge, convFee) : installmentCharge } ]
        })
            );
        }
        if (installmentCharge >= 1) {

            dispatch(bindFinalDonationAmountError(false));
            if (recurringMethods
        && recurringMethods !== 'Subscription') {

                dispatch(bindFinalDonationAmount(installmentCharge));

            }
            if (rValue && rValue.amountsection === -1) {

                dispatch(
          bindMeetFormData({
              formdata: meetFormData.formdata
                  ? meetFormData.formdata.map(q => {
                      return {
                          ...q,
                          recurrings: recurringselection,
                          amountsection: -1,
                          other_amount: IsConvFeeSelected ? getRemovedFee(installmentCharge, convFee) : installmentCharge
                      };
                  })
                  : [ { amountsection: -1 } ]
          })
                );

            } else {

                dispatch(
          bindMeetFormData({
              formdata: meetFormData.formdata
                  ? meetFormData.formdata.map(q => {
                      return {
                          ...q,
                          recurrings: recurringselection,
                          amountsection: IsConvFeeSelected ? getRemovedFee(installmentCharge, convFee) : installmentCharge
                      };
                  })
                  : [ { amountsection: IsConvFeeSelected ? getRemovedFee(installmentCharge, convFee) : installmentCharge } ]
          })
                );

            }
        }
    };

    const onInstallmentChange = e => {
        const format = /^\d+$/;
        const val = Math.trunc(e.target.value);

        if (val.toString().length <= 3 && format.test(val)) {
            dispatch(bindInstallements(val));
        }

        const donAmt = recurringMethods !== 'Subscription' && installments ? getDecimalPoint(donationamount, installments, '') : parseFloat(donationamount);
        const calFee = calcConvenienceFee(
            donAmt,
            convfeedata.AdditionalFeePercentage,
            convfeedata.AdditionalFeeAmount,
            recurringMethods === 'Subscription' ? '' : installments,
            recurringselection,
            convfeedata.AdjustFee,
            recurringMethods
        );
        const Iamount = getPaymentAmount(
          donationamount === -1 ? finalInstallmentAmt : donationamount,
          val,
          calFee, IsConvFeeSelected, recurringMethods, recurringselection
        );

        dispatch(bindInstallmentChargeValue(removedecimal(Iamount)));
        dispatch(bindConvenienceFeeAmount(removedecimal(calFee)));

        dispatch(bindIsInDefiniteRecurring(false));
        dispatch(bindIsInstallmentTouched(true));

    };

    const onIndefiniteChange = () => {
        dispatch(bindIsInDefiniteRecurring(true));
        dispatch(bindInstallements(''));
        setPeriodChange(false);
        dispatch(bindInstallmentErrorMsg(''));
        dispatch(bindInstallmentError(false));
    };
    const onnotIndefiniteChange = () => {
        setPeriodChange(true);
        dispatch(bindIsInDefiniteRecurring(false));

    };
    const handleFocus = () => {
        setIsReadOnly(false);
    };

    return (
        <>
            {
                recurringselection
        && recurringselection !== 'One Time Only' && (
                    <div className = 'form_input_wrapper'>
                        {recurringMethods
            && recurringMethods === 'Subscription' ? (
                                <>

                                    <div className = 'form_input_wrapper'>
                                        {noofperiodicity <= 998 && (
                                            <label>
                                                {t('clickandpledge.pleaseChargeMyCard', {
                                                    currency: formSettings?.Currency || '$',
                                                    amount: finalInstallmentAmt === -1 ? '0.00' : numberFormatter.format(finalInstallmentAmt),
                                                    period: recurringselection
                                                })}
                                            </label>
                                        )}

                                        {/** this is for openfield subscription */}
                                        {noofperiodicity === -1 ? (
                                            <>
                                                <div
                                                    className = 'radio_btn_wrapper'
                                                    style = { marginTopStyle }>

                                                    <label
                                                        className = 'form-check-label'
                                                        htmlFor = 'radioPeriodicity_1'>
                                                        <input
                                                            checked = { periodChange || installments }
                                                            className = 'radio-recurring'
                                                            name = 'isindefinite'
                                                            onChange = { onnotIndefiniteChange }
                                                            type = 'radio' /> {t('clickandpledge.for')}
                                                    </label>
                                                    <input
                                                        className = { `${installmenterr ? 'input-error' : ''}` }
                                                        id = 'periodicity_input'
                                                        onBlur = { e => onRecBlur(e) }
                                                        onChange = { e => onInstallmentChange(e) }
                                                        onFocus = { handleFocus }
                                                        onTouchStart = { handleFocus } // for ios
                                                        readOnly = { isReadOnly }
                                                        type = 'text'
                                                        value = { installments } />
                                                    <label
                                                        className = 'form-check-label'
                                                        htmlFor = 'radioPeriodicity_1'>
                                                        {t('clickandpledge.periods')}
                                                    </label>
                                                    <br /><label className = 'form-check-label'><input
                                                        checked = { !installments && IsInDefiniteRecurring }
                                                        className = 'radio-recurring'
                                                        name = 'isindefinite'
                                                        onChange = { onIndefiniteChange }
                                                        type = 'radio' /> {t('clickandpledge.untilICancelIt')}</label>
                                                </div>
                                            </>
                                        )
                                            : noofperiodicity <= 998 && (
                                                <div
                                                    className = 'radio_btn_wrapper'
                                                    style = { marginTopStyle }>
                                                    <label
                                                        className = 'form-check-label'
                                                        htmlFor = 'radioPeriodicity_1'>
                                                        {t('clickandpledge.for')}
                                                    </label>
                                                    <input
                                                        className = { `${installmenterr ? 'input-error' : ''}` }
                                                        disabled = { isDisabled }
                                                        id = 'periodicity_input'
                                                        maxLength = { 3 }
                                                        onBlur = { e => onRecBlur(e) }
                                                        onChange = { e => onInstallmentChange(e) }
                                                        onFocus = { handleFocus }
                                                        onTouchStart = { handleFocus } // for ios
                                                        readOnly = { isReadOnly }
                                                        type = 'text'
                                                        value = { installments } />
                                                    <label
                                                        className = 'form-check-label'
                                                        htmlFor = 'radioPeriodicity_1'>
                                                        {t('clickandpledge.periods')}
                                                    </label>
                                                </div>
                                            )

                                        }

                                    </div>
                                </>
                            ) : (
                                <>

                                    <div className = 'form_input_wrapper'>
                                        <div
                                            className = 'radio_btn_wrapper'
                                            style = { marginTopStyle }>
                                            <label
                                                className = 'form-check-label'
                                                htmlFor = 'radioPeriodicity_1'>
                                                {t('clickandpledge.divideMyTotalInto')}{' '}
                                            </label>
                                            <input
                                                className = { `${installmenterr ? 'input-error' : ''}` }
                                                id = 'periodicity_input'
                                                maxLength = { 3 }
                                                onBlur = { e => onRecBlur(e) }
                                                onChange = { e => onInstallmentChange(e) }
                                                onFocus = { handleFocus }
                                                onTouchStart = { handleFocus } // for ios
                                                readOnly = { isReadOnly }
                                                type = 'text'
                                                value = { installments } />
                                            <label
                                                className = 'form-check-label'
                                                htmlFor = 'radioPeriodicity_1'>
                                                {t('clickandpledge.installments')}
                                            </label><br />
                                            <label>
                                                {t('clickandpledge.pleaseChargeMyCardUntilPaidOff', {
                                                    currency: formSettings?.Currency || '$',
                                                    amount: finalInstallmentAmt === -1 ? '0.00' : numberFormatter.format(finalInstallmentAmt),
                                                    period: recurringselection
                                                })}
                                            </label>
                                        </div>
                                    </div>
                                </>
                            )}

                        {installmenterr
              && <p className = 'text-danger'>{installmenterrmsg}</p>
                        }
                    </div>
                )}
        </>
    );
};

export default translate(Installments);
